import React from 'react';
import css from './CrewCardSkeleton.module.css';

/**
 * Skeleton placeholder for CrewCard with shimmer.
 * Matches CrewCard layout (image + name + status + fans) for Featured Crews loading/error state.
 * Shimmer disabled when user prefers reduced motion.
 */
const CrewCardSkeleton = () => {
  return (
    <div className={css.skeletonCard} aria-hidden="true">
      <div className={`${css.sk} ${css.skImage}`} />
      <div className={css.skContent}>
        <div className={`${css.sk} ${css.skLine} ${css.skTitle}`} />
        <div className={`${css.sk} ${css.skLine}`} />
        <div className={`${css.sk} ${css.skLine} ${css.skShort}`} />
      </div>
    </div>
  );
};

export default CrewCardSkeleton;
